import React,{ useState } from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';
//import {getFromStorage, setInStorage,removeFromStorage} from "../utils/storage";
import {AiOutlineCloseCircle} from 'react-icons/ai';
import '../App.css';

//server endpoint
import {ENDPOINT} from '../utils/Constants.js';

function SignOut(props){
  let isShowing = props.isShowing;
  let hide = props.hide;
  let [isWaiting,setIsWaiting] = useState(true) //set state isLoading for different renders during API call and after
  let {signedIn, userToken, userID} = props.userInfo;
  //pass changed states upwards to Header
  function handleChange(newUserInfo){
    newUserInfo.signedIn=false
    props.onChange(newUserInfo);
  }
  //Displaying the HTML on clicked Logout button
  if(isShowing){
    //API call for Logout
    if (signedIn){
    fetch(ENDPOINT + '/api/account/logout?token='+userToken+ '&userid=' + userID)
        .then(res => res.json())
        .then(json => {
            console.log(json)
            if(json.success){
              //on successful logout, update signedIn state, userInfo etc.
              handleChange({userToken:'', userName:'', userID:'', email:'', role:'anon',timeSlot:false, participated:[], group:''});
              setIsWaiting(false);
            }
        })
      }
    return(
      ReactDOM.createPortal(
        <React.Fragment>
          <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
            <div className="modal-overlay" onClick={hide}/>
            <div className="modal">
              <div className="modal-header">
                <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
                  <span aria-hidden="true"><AiOutlineCloseCircle/></span>
                </button>
              </div>
              <div className='center' style={{display: isWaiting ? "block" : "none"}}>
                <h2>Logging you out...</h2>
              </div>
              <div className='center' style={{display: signedIn ? "none" : "block"}}>
                <h2>You have successfully logged out.</h2>
                <h2>Have a nice day!</h2>
              </div>
            </div>
          </div>
        </React.Fragment>, document.body
      )
    )
  }
  else{
    return null
    //user was not signed in or the box is not showing, both of which should not happen if the Logout button is visible
  }
}

export default SignOut;
